<template>
  <el-dialog
    title="删除确认"
    :visible.sync="dialogVisible"
    width="30%"
    center
  >
    <div style="text-align:center">
      <p>确定删除会员等级吗？</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">点错了</el-button>
      <el-button type="primary" @click="handleConfirm">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteShopVipLevel } from '@/api/user/shopVipLevelApi'

export default {
  name: 'DeleteShopVipLevel',
  data() {
    return {
      dialogVisible: false,
      currentRow: null
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.currentRow = row
    },
    async handleConfirm() {
      try {
        await deleteShopVipLevel({
          vipLevelId: this.currentRow.vipLevelId
        })
        this.$message.success('删除成功')
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>